import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function ReparerPlutot() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-xl overflow-hidden border border-brand-border order-2 lg:order-1">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20technician%20carefully%20repairing%20a%20white%20roller%20shutter%20mechanism%20with%20precision%20tools%2C%20close-up%20of%20hands%20working%20on%20the%20shutter%20motor%20and%20gears%2C%20bright%20workshop%20lighting%2C%20clean%20and%20professional%20atmosphere%2C%20warm%20neutral%20tones%2C%20high%20quality%20photography%2C%20detailed%20repair%20work%2C%20soft%20beige%20and%20white%20colors&width=700&height=520&seq=reparer_depannage&orientation=landscape"
              alt="Réparation précise d'un volet roulant par un technicien à Strasbourg"
              className="w-full h-[340px] md:h-[420px] object-cover object-top"
            />
          </div>

          <div className="order-1 lg:order-2">
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-5">
              Réparer plutôt que remplacer
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              Dans la majorité des cas, une réparation suffit. Un changement de sangle, un réglage de fins de course ou une reprogrammation de télécommande peuvent remettre votre volet en service pour une fraction du coût d’un remplacement complet.
            </p>
            <p className="text-brand-text text-base leading-relaxed mb-8">
              Notre approche est simple : toujours privilégier la solution la plus économique pour vous. Notre technicien diagnostique la panne avant toute décision. Si le remplacement d’une pièce est nécessaire, nous vous proposons la pièce adaptée à votre marque et votre modèle, installée sur place.
            </p>

            <a
              href="tel:0374473240"
              className="flex items-center justify-center gap-2 bg-brand-cyan text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap mx-auto"
            >
              <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
              Appeler le 03 74 47 32 40
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}